// A generic box explorer hook for when you don't have any specific needs for
// logging or passing through specific fields.
const BoxExplorerHook = {
  mounted() {
    this.initBoxExplorer();
  },

  updated() {
    this.initBoxExplorer();
  },

  initBoxExplorer() {
    const folderId = this.el.dataset.boxFolderId;
    const userId = this.el.dataset.userId;

    this.pushEventTo(
      "#box-explorer-container",
      "get-access-token",
      { folderId: folderId, userId: userId },
      (reply, _) => {
        var contentExplorer = new Box.ContentExplorer();

        contentExplorer.show(folderId, reply.access_token, {
          container: "#box-explorer-container",
          logoUrl: "/images/logo_icon_dark.svg",
          canDelete: false,
          canUpload: false,
        });
      },
    );
  },
};

const BoxPickerHook = {
  mounted() {
    this.initBoxPicker();
  },

  updated() {
    this.initBoxPicker();
  },

  initBoxPicker() {
    const folderId = this.el.dataset.boxFolderId;

    this.pushEventTo(
      "#box-picker-container",
      "get-access-token",
      { folderId: folderId },
      (reply, _) => {
        var contentPicker;
        if (this.el.dataset.pickerType === "file") {
          contentPicker = new Box.FilePicker();
        } else {
          contentPicker = new Box.FolderPicker();
        }

        contentPicker.addListener("choose", (event) => {
          this.pushEventTo("#box-picker-container", "choose-from-picker", {
            id: event[0].id,
            name: event[0].name,
          });
        });

        contentPicker.addListener("cancel", (event) => {
          this.pushEventTo("#box-picker-container", "cancel-picker", {});
        });

        contentPicker.show(folderId, reply.access_token, {
          container: "#box-picker-container",
          logoUrl: "/images/logo_icon_dark.svg",
          maxSelectable: 1,
          size: "large",
        });
      },
    );
  },
};

const DealBoxExplorerHook = {
  mounted() {
    this.initBoxExplorer();
  },

  updated() {
    this.initBoxExplorer();
  },

  initBoxExplorer() {
    const folderId = this.el.dataset.boxFolderId;
    const userId = this.el.dataset.userId;
    const dealReviewName = this.el.dataset.dealReviewName;
    const dealReviewUuid = this.el.dataset.dealReviewUuid;
    const mainsharesUserId = this.el.dataset.mainsharesUserId;
    const dealReviewProgress = this.el.dataset.dealReviewProgress;

    this.pushEventTo(
      "#box-explorer-container",
      "get-access-token",
      { folderId: folderId, userId: userId },
      (reply, _) => {
        var contentExplorer = new Box.ContentExplorer();

        // This event is fired when a user uploads box files.
        contentExplorer.addListener("upload", (event) => {
          window.analytics.track(
            "Deal Review Files Uploaded",
            mainsharesUserId,
            {
              dealReviewName: dealReviewName,
              dealReviewUuid: dealReviewUuid,
            },
          );
          this.pushEventTo("#box-explorer-container", "files-uploaded", {
            dealReviewName: dealReviewName,
            dealReviewUuid: dealReviewUuid,
            files: event,
          });
        });
        //
        // This event is fired when a user deletes box files.
        contentExplorer.addListener("delete", (event) => {
          window.analytics.track(
            "Deal Review Files Deleted",
            mainsharesUserId,
            {
              dealReviewName: dealReviewName,
              dealReviewUuid: dealReviewUuid,
            },
          );
          this.pushEventTo("#box-explorer-container", "files-deleted", {
            dealReviewName: dealReviewName,
            dealReviewUuid: dealReviewUuid,
            files: event,
          });
        });

        contentExplorer.show(folderId, reply.access_token, {
          container: "#box-explorer-container",
          logoUrl: "/images/logo_icon_dark.svg",
          canDelete: dealReviewProgress === "pending",
          canUpload: dealReviewProgress === "pending",
        });
      },
    );
  },
};

const DealBoxPreviewHook = {
  mounted() {
    this.initBoxPreview();
  },

  updated() {
    this.initBoxPreview();
  },

  initBoxPreview() {
    const { Preview } = Box;
    const fileId = this.el.dataset.boxFileId;
    const userId = this.el.dataset.userId;

    this.pushEventTo(
      "#box-preview-container",
      "get-access-token",
      { fileId: fileId, userId: userId },
      (reply, _) => {
        var preview = new Preview();

        preview.show(fileId, reply.access_token, {
          container: "#box-preview-container",
          logoUrl: "/images/logo_icon_dark.svg",
          showDownload: true,
        });
      },
    );
  },
};

const DealBoxUploaderHook = {
  mounted() {
    this.initBoxUploader();
  },

  updated() {
    this.initBoxUploader();
  },

  initBoxUploader() {
    const { ContentUploader } = Box;
    const folderId = this.el.dataset.boxFolderId;
    const userId = this.el.dataset.userId;
    const dealReviewName = this.el.dataset.dealReviewName;
    const dealReviewUuid = this.el.dataset.dealReviewUuid;
    const mainsharesUserId = this.el.dataset.mainsharesUserId;

    this.pushEventTo(
      "#box-upload-container",
      "get-access-token",
      { folderId: folderId, userId: userId },
      (reply, _) => {
        var contentUploader = new ContentUploader();

        // This event is fired when a user uploads box files.
        contentUploader.addListener("complete", (event) => {
          window.analytics.track(
            "Deal Review Files Uploaded",
            mainsharesUserId,
            {
              dealReviewName: dealReviewName,
              dealReviewUuid: dealReviewUuid,
            },
          );
          this.pushEventTo("#box-upload-container", "files-uploaded", {
            dealReviewName: dealReviewName,
            dealReviewUuid: dealReviewUuid,
            files: event,
          });
        });
        //
        // This event is fired when a user clicks the close button.
        contentUploader.addListener("close", (event) => {
          this.pushEventTo("#box-upload-container", "close-uploader", {});
        });

        contentUploader.show(folderId, reply.access_token, {
          container: "#box-upload-container",
          logoUrl: "/images/logo_icon_dark.svg",
        });
      },
    );
  },
};

const InvestmentOpportunityBoxExplorerHook = {
  mounted() {
    this.initBoxExplorer();
  },

  updated() {
    this.initBoxExplorer();
  },

  initBoxExplorer() {
    const folderId = this.el.dataset.boxFolderId;
    const userId = this.el.dataset.userId;
    const title = this.el.dataset.opportunityTitle;
    const opportunityId = this.el.dataset.opportunityId;
    const mainsharesUserId = this.el.dataset.mainsharesUserId;

    this.pushEvent(
      "get-access-token",
      { folderId: folderId, userId: userId },
      (reply, _) => {
        var contentExplorer = new Box.ContentExplorer();

        // This event is fired when a user selects a box item. Fired for both folders and files.
        contentExplorer.addListener("select", function (event) {
          event = event[0];
          window.analytics.track("Data Room Item Selected", mainsharesUserId, {
            type: event.type,
            name: event.name,
            title: title,
            opportunityId: opportunityId,
          });
        });

        // This event is fired when a user views a box file.
        contentExplorer.addListener("preview", function (event) {
          window.analytics.track("Data Room File Previewed", mainsharesUserId, {
            name: event.name,
            title: title,
            opportunityId: opportunityId,
          });
          this.pushEvent("preview-box-file", {
            name: event.name,
            title: title,
            opportunityId: opportunityId,
          });
        });

        // This event is fired when a user downloads a box file.
        contentExplorer.addListener("download", function (event) {
          window.analytics.track(
            "Data Room File Downloaded",
            mainsharesUserId,
            {
              name: event.name,
              title: title,
              opportunityId: opportunityId,
            },
          );
        });

        // This event is fired when a user clicks into a box folder.
        contentExplorer.addListener("navigate", function (event) {
          trimmedEventName = event.name.time().toLowerCase();
          trimmedOpportunityName = opportunityName.trim().toLowerCase();

          // Navigate is fired when the box folder is loaded on listing page view since it is technically.
          // navigating into the root business folder. We don't want to fire a navigate event then since
          // it is not an action taken by the user
          if (trimmedEventName != trimmedOpportunityName) {
            window.analytics.track(
              "Data Room Folder Opened",
              mainsharesUserId,
              {
                name: event.name,
                title: title,
                opportunityId: opportunityId,
              },
            );
          }
        });

        // Increment data room views when the explorer is shown
        this.pushEvent("increment_data_room_views");

        contentExplorer.show(folderId, reply.access_token, {
          container: "#box-container",
          logoUrl: "/images/logo_icon_dark.svg",
          canDownload: true,
          canDelete: false,
          canRename: false,
          canUpload: false,
          canCreateNewFolder: false,
          canShare: false,
        });
      },
    );
  },
};

export {
  BoxExplorerHook,
  BoxPickerHook,
  DealBoxExplorerHook,
  DealBoxPreviewHook,
  DealBoxUploaderHook,
  InvestmentOpportunityBoxExplorerHook,
};
